<h2>Processed Salon Counts</h2>
<div class="px-2 py-3 contents h-full mapping-grid-container">
    <dx-pivot-grid 
      id="salonCounts" 
      [allowSortingBySummary]="true" 
      [allowSorting]="true" 
      [allowFiltering]="true" 
      [allowExpandAll]="true"
      [showColumnGrandTotals]="false"
      [showColumnTotals]="false"
      [showBorders]="true" 
      [dataSource]="countData">
      <dxo-header-filter
        [allowSearch]="true"
        [showRelevantValues]="true"
        [width]="300"
        [height]="400"
      ></dxo-header-filter>

        <dxo-field-chooser [enabled]="true"></dxo-field-chooser>
        <dxo-field-panel [visible]="true"> </dxo-field-panel>
    </dx-pivot-grid>
</div>
